module.exports = __webpack_public_path__ + "static/media/45_A.249d97fd.png";